// extracted by mini-css-extract-plugin
export default {"chart_text_container":"RateContainer_chart_text_container__YeAn+","text_container":"RateContainer_text_container__HGEnD","chart_container":"RateContainer_chart_container__3EE8j"};